import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getIsLoggedIn } from '../../store/order/order.selectors';

/**
 * If is not logged in,
 * redirect to login page and come back to target url
 * after login success
 * N.B.: login via userId bypasses AuthGuard
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private store: Store, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (route.queryParams.jwt) return true; // Bypass auth guard if login via userid

    return this.store.select(getIsLoggedIn).pipe(
      take(1),
      map(isLoggedIn => {
        if (!isLoggedIn) {
          const futureUrl = new URL(location.href);
          this.router.navigateByUrl(
            `/?login=true&login-redirect-url=${encodeURI(futureUrl.pathname + futureUrl.search)}`
          );
          return false;
        }
        return true;
      })
    );
  }
}
